import React from 'react';
import { pdf } from '@react-pdf/renderer';
import SystemTicketPdfDocument from '../../components/SystemTicketPdfDocument';
import { buildSystemTicketPages } from './SystemTicketRenderer';

const buildTicketPdfUrl = async (rawData) => {
    const pages = buildSystemTicketPages(rawData);
    const document = React.createElement(SystemTicketPdfDocument, { pages });
    const blob = await pdf(document).toBlob();
    return URL.createObjectURL(blob);
};

class BrowserPrinter {
    isSupported() {
        return typeof window !== 'undefined' && typeof window.print === 'function';
    }

    async print(rawData) {
        if (!this.isSupported()) {
            throw new Error('El dialogo de impresion no esta disponible en este navegador.');
        }

        const pdfUrl = await buildTicketPdfUrl(rawData);
        return new Promise((resolve, reject) => {
            const frame = document.createElement('iframe');
            let printStarted = false;
            let cleaned = false;
            frame.setAttribute('title', '');
            frame.style.position = 'fixed';
            frame.style.left = '-10000px';
            frame.style.top = '0';
            frame.style.width = '1px';
            frame.style.height = '1px';
            frame.style.border = '0';
            frame.style.visibility = 'hidden';

            const removeFrame = () => {
                if (cleaned) return;
                cleaned = true;
                if (frame.parentNode) frame.parentNode.removeChild(frame);
                URL.revokeObjectURL(pdfUrl);
            };

            frame.onload = () => {
                if (printStarted) return;
                printStarted = true;
                try {
                    const printWindow = frame.contentWindow;
                    const cleanupAfterPrint = () => window.setTimeout(removeFrame, 0);
                    printWindow.addEventListener('afterprint', cleanupAfterPrint, { once: true });
                    printWindow.focus();
                    printWindow.print();
                    resolve();
                } catch (error) {
                    removeFrame();
                    reject(error);
                }
            };
            frame.src = pdfUrl;
            document.body.appendChild(frame);
        });
    }
}

export default new BrowserPrinter();
